module.exports = __webpack_public_path__ + "assets/img/202107-6.4be65332.png";